import { render, staticRenderFns } from "./detail-revenue.vue?vue&type=template&id=1ebba881&scoped=true&"
import script from "./detail-revenue.vue?vue&type=script&lang=js&"
export * from "./detail-revenue.vue?vue&type=script&lang=js&"
import style0 from "./detail-revenue.vue?vue&type=style&index=0&id=1ebba881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebba881",
  null
  
)

export default component.exports